import { render, staticRenderFns } from "./ElementOverviewCategories.vue?vue&type=template&id=86fec1de&scoped=true&"
import script from "./ElementOverviewCategories.vue?vue&type=script&lang=js&"
export * from "./ElementOverviewCategories.vue?vue&type=script&lang=js&"
import style0 from "./ElementOverviewCategories.vue?vue&type=style&index=0&id=86fec1de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fec1de",
  null
  
)

export default component.exports